import { NgModule } from '@angular/core';

import { LandingComponent } from './landing.component';

@NgModule({
  declarations: [
    LandingComponent
  ],
  imports: [
  ]
})
export class LandingModule { }
